/* Papers Browser — filter + list-detail interaction + fixed detail height */
(function () {
  var sections = document.querySelectorAll('.papers-browser');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var pills = section.querySelectorAll('.papers-browser__pill');
    var items = section.querySelectorAll('.papers-browser__item');
    var panels = section.querySelectorAll('.papers-browser__detail-panel');
    var detail = section.querySelector('.papers-browser__detail');
    var status = section.querySelector('[data-papers-status]');

    /* Measure tallest panel, lock detail height, and match list height */
    function lockHeights() {
      /* Find tallest detail panel */
      var maxH = 0;
      panels.forEach(function (p) {
        p.style.display = 'block';
        p.style.minHeight = '';
        var h = p.offsetHeight;
        if (h > maxH) maxH = h;
        p.style.display = '';
      });
      if (maxH > 0) {
        detail.style.setProperty('--detail-height', maxH + 'px');
      }

      /* Measure current list height and distribute extra padding if list is shorter */
      var list = section.querySelector('.papers-browser__list');
      if (list && maxH > 0) {
        /* Reset item padding first */
        items.forEach(function (item) { item.style.paddingTop = ''; item.style.paddingBottom = ''; });
        var listH = list.offsetHeight;
        if (listH < maxH) {
          var extraPerItem = (maxH - listH) / items.length / 2;
          var pad = Math.max(extraPerItem, 0);
          items.forEach(function (item) {
            var base = 12;
            item.style.paddingTop = (base + pad) + 'px';
            item.style.paddingBottom = (base + pad) + 'px';
          });
        }
      }
    }

    lockHeights();
    window.addEventListener('resize', lockHeights);

    /* Filter */
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var filter = pill.getAttribute('data-filter');

        pills.forEach(function (p) {
          p.classList.remove('papers-browser__pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('papers-browser__pill--active');
        pill.setAttribute('aria-pressed', 'true');

        var firstVisible = null;
        var visibleCount = 0;
        items.forEach(function (item) {
          var theme = item.getAttribute('data-theme');
          if (filter === 'all' || theme === filter) {
            item.classList.remove('papers-browser__item--hidden');
            visibleCount++;
            if (!firstVisible) firstVisible = item;
          } else {
            item.classList.add('papers-browser__item--hidden');
            item.classList.remove('papers-browser__item--active');
          }
        });

        if (firstVisible) selectItem(firstVisible, false);
        if (status) {
          var label = pill.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
          status.textContent = 'Showing ' + visibleCount + ' ' +
            (visibleCount === 1 ? 'source' : 'sources') +
            (filter === 'all' ? '' : ' in ' + label) + '.';
        }
      });
    });

    /* Select item — click + keyboard (Enter/Space) */
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        selectItem(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectItem(item);
        }
      });
    });

    function selectItem(item, announce) {
      var index = item.getAttribute('data-index');

      items.forEach(function (i) {
        i.classList.remove('papers-browser__item--active');
        i.setAttribute('aria-pressed', 'false');
      });
      item.classList.add('papers-browser__item--active');
      item.setAttribute('aria-pressed', 'true');

      panels.forEach(function (p) {
        p.classList.remove('papers-browser__detail-panel--active');
      });
      var target = section.querySelector('[data-panel="' + index + '"]');
      if (target) target.classList.add('papers-browser__detail-panel--active');

      if (announce !== false && status) {
        var titleEl = item.querySelector('.papers-browser__item-title');
        if (titleEl) status.textContent = 'Showing: ' + titleEl.textContent.trim();
      }
    }
  });
})();
